/** Default label when report name is unavailable. */
export const POWER_BI_REPORT_LABEL = 'Power BI Report';
